import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from '@modules/main/main.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {LoginComponent} from '@modules/login/login.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {AuthGuard} from '@guards/auth.guard';
import {NonAuthGuard} from '@guards/non-auth.guard';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {SubMenuComponent} from '@pages/main-menu/sub-menu/sub-menu.component';
import { HomeComponent } from '@pages/home/home.component';
import { GeoPortalComponent } from '@pages/geo-portal/geo-portal.component';
import { PlanDashboardComponent } from '@pages/plan-dashboard/plan-dashboard.component';
import { ParcelDashboardComponent } from '@pages/parcel-dashboard/parcel-dashboard.component';
import { AdminHomeComponent } from '@pages/admin-home/admin-home.component';
import { UserHomeComponent } from '@pages/user-home/user-home.component';
import { EngHomeComponent } from '@pages/eng-home/eng-home.component';
import { ParcelEditComponent } from '@pages/parcel-edit/parcel-edit.component';
import { EngPlanEditComponent } from '@pages/eng-plan-edit/eng-plan-edit.component';
import { EngParcelEditComponent } from '@pages/eng-parcel-edit/eng-parcel-edit.component';
import { GeoPortalBaladeyaComponent } from '@pages/baladya-map/geoPortalBaladeya/geo-portal-baladeya/geo-portal-baladeya.component';
import { LandingPageComponent } from '@pages/landing-page/landing-page.component';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'profile',
                component: ProfileComponent
            },
            {
                path: 'blank',
                component: BlankComponent
            },
            {
                path: 'sub-menu-1',
                component: SubMenuComponent
            },
            {
                path: 'sub-menu-2',
                component: BlankComponent
            },
            {
                path: 'dashboard',
                component: DashboardComponent
            },
            {
                path: 'plandashboard',
                component: GeoPortalComponent
            },
            {
                path: 'geoportal',
                component: PlanDashboardComponent
            },
            {
                path: 'parceldashboard',
                component: ParcelDashboardComponent
            },
            {
                path: 'homeuserediting',
                component: UserHomeComponent
            },
            {
                path: 'homeeng',
                component: EngHomeComponent
            },
            {
                path: 'homeadmin',
                component: AdminHomeComponent
            },
            {
                path: 'parceledit',
                component: ParcelEditComponent
            },
            {
                path: 'engPlanEdit',
                component: EngPlanEditComponent
            },
            {
                path: 'engParcelEdit',
                component: EngParcelEditComponent
            },

            {
                path: 'geoPortalBaladya',
                component: GeoPortalBaladeyaComponent
            },
            {
                path: 'landing',
                component: LandingPageComponent
            },
            {
                path: '',
                component: LandingPageComponent
            }
        ]
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {
        path: 'recover-password',
        component: RecoverPasswordComponent,
        canActivate: [NonAuthGuard]
    },
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled',scrollPositionRestoration:'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
